import { render, staticRenderFns } from "./invitePet.vue?vue&type=template&id=928f2078&"
import script from "./invitePet.vue?vue&type=script&lang=js&"
export * from "./invitePet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports